import script from "./IDESideBarContentTabDownload.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDESideBarContentTabDownload.vue?vue&type=script&lang=ts&setup=true"

import "./IDESideBarContentTabDownload.vue?vue&type=style&index=0&id=b8f4a46e&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8f4a46e"]])

export default __exports__